// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"j1-z","colorTextValue":"k1-z","swatches":"l1-z","collapseLink":"m1-z","isCollapsed":"n1-z","dropdown":"o1-z","disabled":"p1-z"};